import "./SuvaiAbout.scss"
import thali from "../../assets/images/thali.png"
import snacks from "../../assets/images/snacks.png"
import { sortByOrderAscending } from "../../helper/helper";
import { useEffect } from "react";
import Button from "../../components/button/Button";

const SuvaiAbout = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const Components = [
        {
            "ID": "SuvaiAbout-componentOne",
            "Order": 1,
            "Type": "content",
            "Props": null,
            "Components": [
                {
                    "ID": "SuvaiAbout-componentOne-TextContainer",
                    "Order": 1,
                    "Type": "content",
                    "Props": null,
                    "Data": [
                        {
                            "text": "<b>SUVAI FUSION</b> is a vibrant multi-cuisine restaurant based in Mansfield, Nottingham, bringing together the bold flavours of Sri Lankan, Indian, and Indo-Chinese cuisine under one roof."
                        },
                        {
                            "text": " From sizzling kothu roti and aromatic biryanis to crispy dosas, rich curries, and flavour-packed fusion dishes, every plate at SUVAI FUSION is crafted with authentic spices, fresh ingredients, and a passion for true taste."
                        },
                        {
                            "text": " Whether you're joining us for a relaxed family meal, grabbing a quick bite with friends, or ordering your favourites to enjoy at home, SUVAI FUSION delivers unforgettable flavour in every bite.Authentic Taste. Modern Twist. True Fusion."
                        }
                    ]
                },
                {
                    "ID": "SuvaiAbout-componentOne-ImageContainer",
                    "Order": 2,
                    "Type": "content",
                    "Props": {
                        "bgSrc": snacks,
                        "text": "About Us"
                    },
                }

            ]
        },
        {
            "ID": "SuvaiAbout-componentTwo",
            "Order": 2,
            "Type": "content",
            "Props": null,
            "Components": [
                {
                    "ID": "SuvaiAbout-componentTwo-ImageContainer",
                    "Order": 1,
                    "Type": "content",
                    "Props": {
                        "bgSrc": thali,
                    },
                },
                {
                    "ID": "SuvaiAbout-componentTwo-TextContainer",
                    "Order": 2,
                    "Type": "content",
                    "Props": null,
                    "Components": [
                        {
                            "ID": "SuvaiAbout-componentTwo-TextContainer-vertical",
                            "Order": 1,
                            "Type": "text",
                            "Props": {
                                "text": "Elemental cooking methods"
                            },
                        },
                        {
                            "ID": "SuvaiAbout-componentTwo-TextContainer-content",
                            "Order": 2,
                            "Type": "text",
                            "Props": {
                                "text": "Food Philosophy"
                            },
                            "Data": [
                                {
                                    "text": "Our food philosophy celebrates flavours, culture, and creativity from Sri Lankan, Indian, and Indo-Chinese traditions. We believe every dish should be an experience—a perfect harmony of aromas, textures, and tastes that awaken the senses. "
                                },
                                {
                                    "text": "By blending authentic culinary techniques with modern twists, we create dishes that are both comforting and adventurous. Fresh, high-quality ingredients form the heart of our kitchen, thoughtfully combined to craft meals that nourish the body and delight the palate. For us, dining is not just about sustenance—it’s about connection, joy, and the simple pleasure of discovering something extraordinary in every bite."
                                },
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "ID": "SuvaiHome-MobileFixed",
            "Order": 3,
            "Type": "",
            "Props": null,
            "Components": [
                {
                    "ID": "SuvaiHome-MobileFixed-button",
                    "Order": 1,
                    "Type": "button",
                    "Props": {
                        "href": "",
                        "btnText": "Order Now",
                        "padding": "14px 0px",
                        "width": "100%",
                        "type": "PRIMARY"
                    }
                },
                {
                    "ID": "SuvaiHome-MobileFixed-button",
                    "Order": 2,
                    "Type": "button",
                    "Props": {
                        "href": "",
                        "btnText": "Book a table",
                        "padding": "14px 0px",
                        "width": "100%",
                        "type": "SECONDARY"
                    }
                }
            ]
        }
    ]

    const getComponentOneTextContent = (data) => {
        return (
            <div className="SuvaiAbout-inner-textContWarpper">
                <div className="SuvaiAbout-inner-textContWarpper-textCont">
                    {data.map((content, key) => <div
                        key={key}
                        dangerouslySetInnerHTML={{ __html: content?.text }}
                        className="SuvaiAbout-inner-textContWarpper-textCont-content" />)}
                </div>
            </div>
        )
    }
    const getComponentOneImageContent = (props) => {
        return (
            <div
                className="SuvaiAbout-inner-imageCont"
                style={{
                    backgroundImage: `linear-gradient(180deg, rgba(16, 18, 19, 0) 0%, rgba(16, 18, 19, 0.6) 40%, rgba(16, 18, 19, 0.6) 60%, rgba(16, 18, 19, 0) 100%), url(${props?.bgSrc})`
                }} >
                <div
                    className="SuvaiAbout-inner-imageCont-header"
                >
                    {props.text}

                </div>
            </div>
        )
    }
    const getComponentOneContent = (component) => {
        switch (component.ID) {
            case "SuvaiAbout-componentOne-TextContainer":
                return getComponentOneTextContent(component.Data)
            case "SuvaiAbout-componentOne-ImageContainer":
                return getComponentOneImageContent(component.Props)
            default:
                return <div />
        }

    }
    const getComponentTwoTextInnerContent = (component) => {
        return (
            <div className="SuvaiAbout-inner2-textContWarpper-textCont2"
            >
                <div
                    className="SuvaiAbout-inner2-textContWarpper-textCont2-header">
                    {component?.Props?.text}
                </div>
                {component?.Data.map((content, key) => <div
                    key={key}
                    dangerouslySetInnerHTML={{ __html: content?.text }}
                    className="SuvaiAbout-inner2-textContWarpper-textCont2-content" />)}
            </div>
        )
    }
    const getComponentTwoTextContentContent = (component) => {
        switch (component.ID) {
            case "SuvaiAbout-componentTwo-TextContainer-vertical":
                return <div class="SuvaiAbout-inner2-textContWarpper-vertical">{component?.Props?.text}</div>

            case "SuvaiAbout-componentTwo-TextContainer-content":
                return getComponentTwoTextInnerContent(component)
            default:
                return <div />
        }
    }
    const getComponentTwoTextContent = (components) => {
        return (
            <div className="SuvaiAbout-inner2-textContWarpper">
                {sortByOrderAscending(components).map((component, key) => {
                    return getComponentTwoTextContentContent(component)
                })}
            </div>
        )
    }
    const getComponentTwoContent = (component) => {
        switch (component.ID) {
            case "SuvaiAbout-componentTwo-TextContainer":
                return getComponentTwoTextContent(component.Components)
            case "SuvaiAbout-componentTwo-ImageContainer":
                return <div
                    className="SuvaiAbout-inner2-imageCont"
                    style={{
                        backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${component?.Props?.bgSrc})`
                    }} >
                </div>
            default:
                return <div />
        }

    }
    const getComponentOne = (components) => {
        return (
            <div className="SuvaiAbout-inner">
                {sortByOrderAscending(components).map((component, key) => {
                    return getComponentOneContent(component)
                })}
            </div>
        )
    }
    const getComponentTWo = (components) => {
        return (
            <div className="SuvaiAbout-inner2">
                {sortByOrderAscending(components).map((component, key) => {
                    return getComponentTwoContent(component)
                })}
            </div>
        )
    }
    const getcomponentFixedContainerComponents = (component) => {
        switch (component.ID) {
            case "SuvaiHome-MobileFixed-button":
                return <Button
                    text={component?.Props.btnText}
                    padding={component?.Props?.padding}
                    width={component?.Props.width}
                    type={component?.Props.type}
                    onClick={() => {
                        if (component?.Props?.href && component?.Props?.href !== "") {
                            window.open(component?.Props?.href, '_blank')
                        }
                    }} />
            default:
                return <div />
        }

    }
    const getcomponentFixedContainer = (components) => {
        return (<div className="SuvaiHome-MobileFixed">
            {sortByOrderAscending(components).map((component, key) => {
                return getcomponentFixedContainerComponents(component)
            })}
        </div>)
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "SuvaiAbout-componentOne":
                return getComponentOne(component.Components)
            case "SuvaiAbout-componentTwo":
                return getComponentTWo(component.Components)
            case "SuvaiHome-MobileFixed":
                return getcomponentFixedContainer(component?.Components)

            default:
                return <div />
        }

    }
    return (
        <div className="SuvaiAbout">
            {sortByOrderAscending(Components).map((component, key) => {
                return getComponents(component)
            })}
        </div>
    )
}
export default SuvaiAbout